"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionReducerMap = exports.sessionUpdatedAction = void 0;

var _reduxUtils = require("@dealersocket/redux-utils");

var _reduxOidc = require("redux-oidc");

var _lifecycle = require("../lifecycle.reducer");

var _userManager = require("../internal/user-manager");

var _actionReducerMap;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var postfix = "/".concat(_lifecycle.lifecycleReducer.sliceName, "/app");
var SESSION_UPDATED = "SESSION_UPDATED".concat(postfix);
var sessionUpdatedAction = (0, _reduxUtils.createAction)(SESSION_UPDATED);
exports.sessionUpdatedAction = sessionUpdatedAction;

function redirectToLogin() {
  localStorage.setItem('returnHash', window.location.hash && window.location.hash.substr(1));
  (0, _userManager.getUserManager)().signinRedirect();
}

var actionReducerMap = (_actionReducerMap = {}, _defineProperty(_actionReducerMap, SESSION_UPDATED, function (slice, action) {
  // console.log(action.type, action.payload); // eslint-disable-line no-console
  return _objectSpread({}, slice, {
    authSession: action.payload,
    accessToken: action.payload.identity.authTokens.accessToken
  });
}), _defineProperty(_actionReducerMap, _reduxOidc.USER_EXPIRED, function (slice) {
  console.log('User expired. Redirecting to login.'); // eslint-disable-line no-console

  redirectToLogin();
  return slice;
}), _defineProperty(_actionReducerMap, _reduxOidc.SILENT_RENEW_ERROR, function (slice, action) {
  console.warn('Silent renew error. Redirecting to login.', action.payload); // eslint-disable-line no-console

  var userManager = (0, _userManager.getUserManager)();
  userManager.removeUser().then(function () {
    redirectToLogin();
  });
  return slice;
}), _defineProperty(_actionReducerMap, _reduxOidc.USER_SIGNED_OUT, function (slice) {
  console.log('User signed out. Redirecting to login.'); // eslint-disable-line no-console

  redirectToLogin();
  return slice;
}), _defineProperty(_actionReducerMap, _reduxOidc.LOAD_USER_ERROR, function (slice, action) {
  console.warn('Load user error. Redirecting to login.', action.payload); // eslint-disable-line no-console

  var userManager = (0, _userManager.getUserManager)();
  userManager.removeUser().then(function () {
    redirectToLogin();
  });
  return slice;
}), _actionReducerMap);
exports.actionReducerMap = actionReducerMap;

_lifecycle.lifecycleReducer.addActionReducerMap(actionReducerMap);